import apiClient from './apiClient';

export const businessNetworkApi = {
  fetchNetwork: async (networkId) => {
    try {
      const response = await apiClient.get(`/api/v1/BusinessNetwork/FetchNetwork/${networkId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching business network:', error);
      throw error;
    }
  }
};